import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './LoginInterface.css';

const AstroLoginInterface = ({ onCallEnd }) => {
  const { loading, error, astroLogin } = useAuth();
  const [userDob, setUserDob] = useState({ year: '', month: '', day: '' });
  const [partnerDob, setPartnerDob] = useState({ year: '', month: '', day: '' });
  const [includePartner, setIncludePartner] = useState(false);
  const [astroError, setAstroError] = useState('');
  const [astroLoading, setAstroLoading] = useState(false);

  const handleAstroLogin = async (e) => {
    e.preventDefault();
    if (onCallEnd) onCallEnd(); // Reset call end state

    setAstroError('');
    setAstroLoading(true);

    try {
      // Validate user DOB
      if (!userDob.year || !userDob.month || !userDob.day) {
        setAstroError('Please enter your complete date of birth');
        setAstroLoading(false);
        return;
      }

      // Prepare request data
      const requestData = {
        user_dob: {
          year: parseInt(userDob.year),
          month: parseInt(userDob.month),
          day: parseInt(userDob.day)
        }
      };

      // Add partner DOB if included
      if (includePartner) {
        if (!partnerDob.year || !partnerDob.month || !partnerDob.day) {
          setAstroError('Please enter your partner\'s complete date of birth');
          setAstroLoading(false);
          return;
        }
        requestData.partner_dob = {
          year: parseInt(partnerDob.year),
          month: parseInt(partnerDob.month),
          day: parseInt(partnerDob.day)
        };
      }

      // Make API call to start session
      const response = await fetch(process.env.REACT_APP_SERVER_URL+'/astrology/start-session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to start astrology session');
      }

      const data = await response.json();
      const sessionInfo = data.session;

      // Use the astrology login function to authenticate and connect
      await astroLogin(sessionInfo);

      console.log('✅ Astrology session started successfully');

    } catch (err) {
      setAstroError(err.message || 'Something went wrong. Please try again.');
      console.error('Error starting astrology session:', err);
    } finally {
      setAstroLoading(false);
    }
  };

  const renderDateInput = (dob, setDob, label) => (
    <div className="form-group">
      <label>{label}</label>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <select
          value={dob.month}
          onChange={(e) => setDob({ ...dob, month: e.target.value })}
          required
          style={{ flex: '1', minWidth: '120px', padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
        >
          <option value="">Month</option>
          {[...Array(12)].map((_, i) => (
            <option key={i + 1} value={i + 1}>
              {new Date(2024, i, 1).toLocaleString('default', { month: 'long' })}
            </option>
          ))}
        </select>

        <select
          value={dob.day}
          onChange={(e) => setDob({ ...dob, day: e.target.value })}
          required
          style={{ flex: '1', minWidth: '80px', padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
        >
          <option value="">Day</option>
          {[...Array(31)].map((_, i) => (
            <option key={i + 1} value={i + 1}>{i + 1}</option>
          ))}
        </select>

        <input
          type="number"
          placeholder="Year"
          value={dob.year}
          onChange={(e) => setDob({ ...dob, year: e.target.value })}
          min="1900"
          max={new Date().getFullYear()}
          required
          style={{ flex: '1', minWidth: '100px', padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
        />
      </div>
    </div>
  );

  return (
    <div className="login-interface">
      <div className="login-container">
        <div className="login-header">
          <h1>🌟 Astro AI - Luna</h1>
          <p>Connect with Luna, your personal AI astrologer, and discover your cosmic insights</p>
        </div>

        <form onSubmit={handleAstroLogin} className="login-form">
          {renderDateInput(userDob, setUserDob, "Your Date of Birth")}

          <div className="form-group">
            <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={includePartner}
                onChange={(e) => setIncludePartner(e.target.checked)}
                style={{ transform: 'scale(1.2)' }}
              />
              <span>Include partner compatibility analysis</span>
            </label>
          </div>

          {includePartner && renderDateInput(partnerDob, setPartnerDob, "Partner's Date of Birth")}

          <button
            type="submit"
            className="start-campaign-btn"
            disabled={astroLoading || loading}
          >
            {astroLoading || loading ? 'Connecting to Luna...' : 'Start Astrology Session ✨'}
          </button>
        </form>

        {(astroError || error) && (
          <div className="error-message">
            {astroError || error}
          </div>
        )}
      </div>
    </div>
  );
};

export default AstroLoginInterface;